import React from 'react';
import { Form } from 'semantic-ui-react';
import { Grid, Button } from 'semantic-ui-react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  Color: {
    id: 'Color',
    defaultMessage: 'Colore',
  },
});

interface ColorListWidgetProps {
  id: string;
  title?: string;
  required: boolean;
  value?: string;
  onChange: Function;
  colors: Array<any>;
  className: string;
  defaultValue: string;
}

const ColorListWidget: React.FC<ColorListWidgetProps> = (data) => {
  const intl = useIntl();

  return data.colors.length > 0 ? (
    <Form.Field
      inline
      required={data.required}
      className={data.className}
      id={'field-' + data.id}
    >
      <Grid>
        <Grid.Row>
          <Grid.Column
            width="12"
            className="color-list-widget"
            verticalAlign="middle"
          >
            <div className="wrapper">
              <label htmlFor={`field-${data.id}`}>
                {data.title ? data.title : intl.formatMessage(messages.Color)}
              </label>

              <div className="buttons">
                {data.colors.map((color) => {
                  return (
                    <Button
                      key={data.id + color.name}
                      className={color.name}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        data.onChange(data.id, color.name);
                      }}
                      active={
                        data?.value
                          ? data.value === color.name
                          : data?.defaultValue === color.name
                      }
                      circular
                      aria-label={color.label}
                      title={color.label}
                    />
                  );
                })}
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Form.Field>
  ) : null;
};

export default ColorListWidget;
